import { IPromise, IScope } from 'angular'
import { VdEscapeStack } from 'vend.ui'
import { ClientApiSaleData } from '../../../../factories/sale-transformer'
import { $q } from '../../../../ng-compat/imports'
import { AcceptStep } from '../integrated-payment-steps.constant'
import { PaymentData } from './IntegratedPaymentModal'

interface IntegratedPaymentModalOptions {
  paymentData: PaymentData
  saleData: ClientApiSaleData
}
export class IntegratedPaymentModalController {
  public readonly close: () => void
  public readonly paymentData: PaymentData
  public readonly saleData: ClientApiSaleData

  private readonly internalClose: (val: IPromise<AcceptStep>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<AcceptStep>) => void, // todo
    public readonly options: IntegratedPaymentModalOptions,
    private readonly vdEscapeStack: VdEscapeStack
  ) {
    'ngInject'

    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.saleData = options.saleData
    this.paymentData = options.paymentData

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
